import { addTransition } from 'src/styles/theme/utils/functions';
import styled, { css } from 'styled-components';

export const StyledAnimatedArrow = styled.div<{ isActive?: boolean }>`
	${(p) => css`
		${addTransition()}

		transform: rotateX(${p.isActive ? '-180deg' : '0deg'});
	`}
`;
